
import { BACKGROUND_COLOR } from 'interfaces';
import styled from 'styled-components';
import { ParagraphProps } from './query';
import HtmlParser from '@/components/molecules/HtmlParser';
import MarkdownParser from '@/components/molecules/MarkdownParser';
import SubtitleWithIcon from '@/components/molecules/SubtitleWithIcon';
import { isStringWithHtmlElement } from '@/utilities/functions';

const SubtitleWithIconPlaceholder = styled.div`
	padding: 1rem;
`;
const ParagraphContainer = styled.div<{
	withPadding?: boolean;
	backgroundColor: BACKGROUND_COLOR;
}>`
	background-color: ${({ theme, backgroundColor }) => theme.color[backgroundColor]};
	padding: ${({ withPadding }) => withPadding ? '3rem' : '0rem'};
	margin: 2.5em 0;
	border-radius: 8px;
`;

const Paragraph = ({ paragraph }: { paragraph: ParagraphProps }) => {
	return (
		<ParagraphContainer
			backgroundColor={paragraph.backgroundColor?.color ?? BACKGROUND_COLOR.transparent}
			withPadding={paragraph.displayAsBlock}
		>
			{paragraph.title
				? (
					<SubtitleWithIcon
						subtitle={paragraph.title}
						subtitleIcon={paragraph.icon?.name}
					/>
				)
				: <SubtitleWithIconPlaceholder />
			}
			{isStringWithHtmlElement(paragraph.description)
				? (
					<HtmlParser padding={{ top: '-.5rem', bottom: paragraph.displayAsBlock ? '0rem' : '3.5rem' }}>
						{paragraph.description}
					</HtmlParser>
				)
				: (
					<MarkdownParser padding={{ top: '-.5rem', bottom: paragraph.displayAsBlock ? '0rem' : '3.5rem' }}>
						{paragraph.description}
					</MarkdownParser>
				)
			}
		</ParagraphContainer>
	);
};

export default Paragraph;
